import localStorage2 from 'store2'
const userLocalStorage = localStorage2.namespace('users')
const clientApplicationLocalStorage = localStorage2.namespace('clientApplication')

export { userLocalStorage, clientApplicationLocalStorage }
